import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
    selector: '[mzMaxLength]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: MzMaxLengthDirective,
        multi: true
    }]

})
export class MzMaxLengthDirective implements Validator {

    @Input() mzMaxLength: number;
    @Input() textMaxErr: number;

    validate(control: AbstractControl): ValidationErrors | null {

        if (control.value > this.mzMaxLength || 0) {
            return {maxlength: this.textMaxErr || `Максимальное количество символов - ${this.mzMaxLength}`};
        } else {
            return null;
        }
    }

}
